import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ValidateInputService {
  public pattern: RegExp = /^([a-zA-Z'áéíóúñüÁÉÍÓÚÑÜ\s\'\-])+$/;
  constructor() { }

  validateInput(event, isMeasurable?) {
    const key = window.event ? event.which : event.charCode;
    const value = event.key;
    switch (event.target.name) {
      case 'number':
        if (!isMeasurable) {
          if (key < 48 || key > 57) {
            event.preventDefault();
          }
        } else {
          if (key < 46 || key === 47 || key > 57) {
            event.preventDefault();
          }
        }
        break;
      case 'alphabetical':
        if (!this.pattern.test(value)) {
          event.preventDefault();
        }
        break;
    }
  }

  validateWholeNumber(event) {
    const key = window.event ? event.which : event.charCode;
    const value = event.key;
    switch (event.target.name) {
      case 'number':
        if (key < 48 || key > 57) {
          event.preventDefault();
        }
        break;
      case 'alphabetical':
        if (!this.pattern.test(value)) {
          event.preventDefault();
        }
        break;
    }
  }
}
